import { render, staticRenderFns } from "./UnitOfMeasureViewLogs.vue?vue&type=template&id=72fa1f88"
import script from "./UnitOfMeasureViewLogs.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasureViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports